import { DataBean } from "../DataBean";


export class PilaDataSheets extends DataBean {
    public async getPilaDataSheets(idSocialSecuritySpreadSheet: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPilaDataSheets_Number", [idSocialSecuritySpreadSheet]);
    }
    public async setPilaDataApplied(idSocialSecuritySpreadSheet: any, fileName: any, year: any, month: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_setPilaDataApplied_Number_String_Number_Number", [idSocialSecuritySpreadSheet, fileName, year, month]);
    }

}